import { render, staticRenderFns } from "./PocModal.vue?vue&type=template&id=79bff16e"
import script from "./PocModal.vue?vue&type=script&lang=js"
export * from "./PocModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports